import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { UserProductTypes } from '@/types';

export const getUserProducts = ({ groupId }: { groupId: string }): Promise<UserProductTypes[]> => {
  if (groupId) {
    return axios
      .get(PAYMENTS_BACKEND_URL + 'my-products', {
        params: { groupId: groupId },
      })
      .then((response: any) => {
        return response._embedded?.my_products;
      });
  }
  return new Promise((resolve) => {
    resolve([]);
  });
};
